<template>
  <section class="py-[60px] px-[16px] lg:px-[60px] bg-[#FACCDB]" id="faq">
    <!-- 标题区域 -->
    <div class="text-center">
      <h1 class="text-[28px] font-bold mb-[16px]">FAQs</h1>
      <p class="text-[28px] text-align mb-[30px]">Here's some of the FAQs and the answers to them.</p>
    </div>

    <!-- FAQ 卡片 -->
    <div class="w-full max-w-7xl mx-auto [@media(max-width:1280px)]:px-[60px] rounded-[28px] bg-white">
      <div
        v-for="(item, index) in faqData"
        :key="index"
        class="cursor-pointer"
        :class="{
          expanded: expandedItem === index,
        }"
        @click="toggleItem(index)"
      >
        <div class="flex items-center justify-between py-[16px] px-[18px]">
          <span class="text-[24px] font-semibold flex-1 mr-[16px]">{{ item.question }}</span>
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#000" stroke-width="1.5" fill="none" />
            <g stroke="#000" stroke-width="1.5" stroke-linecap="round">
              <path d="M12 6v12" v-if="expandedItem !== index" />
              <path d="M6 12h12" />
            </g>
          </svg>
        </div>
        <div v-if="expandedItem === index" class="faq-answer pl-[42px] pr-[28px] pt-[16px] pb-[16px] text-[18px] text-[#5A5A5A]">
          {{ item.answer }}
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { faqData } from '@/components/faqData.ts'

const expandedItem = ref<number>(0)

const toggleItem = (index: number) => {
  if (expandedItem.value === index) {
    expandedItem.value = -1
  } else {
    expandedItem.value = index
  }
}
</script>

<style scoped lang="less">
.faq-answer {
  line-height: 1.5;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
